import React from "react"

import AddField from "../../../../../../gd-modules/common/add-column-new/add-field"

type Props = {
    addField?   : any
}

export default function AddFieldToolbar(props: Props): JSX.Element | null {

    if (!props.addField) return null

    return (
        <>
            <AddField manageColumnsConfig   = {props.addField.manageColumnsConfig}
                      fields                = {props.addField.fields}
                      showAdd               = {false}
                      onToggleColumn        = {props.addField.onAddField}>
                <div className="ui5-control-button-with-label s-26 active">
                    <div className="ico i5-formula"/>
                    <div className="btn-label">Add field</div>
                </div>
            </AddField>
            <div className="rte-toolbar-separator"/>
        </>
    )
}